import { deserializeData, MayNull } from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import { GuildType } from '@src/constants/guild'
import { guildSchema } from '@src/deserialize/yup/guild'
import graphql from '@src/graphql/query/getMyGuild'
import { Guild } from '@src/types/guild'
import { useCallback, useState } from 'react'

const useGetMyGuild = (): Hook => {
  const [fetchMyGuild, { loading }] = useLazyQuery(graphql)

  const [data, setData] = useState<MayNull<Guild>>(null)

  const fetch = useCallback(
    async (request: Request): Promise<Response> => {
      const response = await fetchMyGuild({
        variables: {
          type: request.type
        }
      })

      const guild = deserializeData<MayNull<Guild>>(
        response,
        guildSchema,
        undefined,
        ['guild']
      )

      setData(guild)

      return guild
    },
    [fetchMyGuild]
  )

  return {
    data,
    loading,
    fetch
  }
}

type Request = {
  type: GuildType
}

type Response = MayNull<Guild>

type Hook = {
  data: MayNull<Guild>
  loading: boolean
  fetch: (request: Request) => Promise<Response>
}

export default useGetMyGuild
